module.exports = __webpack_public_path__ + "static/Japan-8cf4807357f08b226806a358ea855ff4.jpg";